import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { BrandingService } from '../../../services/branding.service';
import { environment } from '../../../../environments/environment';
import { UserService } from '../../../services/user.service';

@Component({
  selector: 'app-app-switcher',
  templateUrl: './app-switcher.component.html',
  styleUrls: ['./app-switcher.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class AppSwitcherComponent implements OnInit {
  environment: any = environment;

  constructor(public brandingService: BrandingService, public userService: UserService) { }

  ngOnInit() {}

  checkJllUser() {
    if(this.userService.loggedIn) {
      return this.userService.loggedInUser.brandingInfo && this.userService.loggedInUser.brandingInfo.brandingKey === 'jll';
    } else {
      return this.brandingService.isJllSite();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/header/app-switcher/app-switcher.component.ts